const KEY = "spend-sense.welcome_seen"

export function hasSeenWelcome(): boolean {
  try {
    return localStorage.getItem(KEY) === "true"
  } catch {
    return false
  }
}

export function markWelcomeSeen(): void {
  try {
    localStorage.setItem(KEY, "true")
  } catch {
    // ignore
  }
}
